import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { YId, YTimeString } from '../y/types';

export interface IOrder {
    id: YId;
    provider_id: YId;
    c_session_id?: YId;
    i_event_id?: YId;
    i_session_id?: YId;
    quantity?: number;
    is_ignored: boolean;
    is_cancelled: boolean;
    is_completed: boolean;
    event_name?: string;
    session_time?: YTimeString;
    expires_at?: YTimeString;
    created_at: YTimeString;
}

export const i_orders = makeDataStore('i/orders', 'i/order', (m: IOrder) => m, Object.assign);

export function iOrderLink(order_id: YId, session_id: YId) {
    return $api.POST(`i/order/${order_id}/link`, { session_id });
}